import React, { useContext, useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { serverStatisticsSelector } from 'libs/redux';
import { Grid, Container } from './styles';
import Box from "app/components/box";
import { I8nContext } from 'libs/i18n';
import { colors } from 'resources/Theme';
import { getColor, getCheckAmountColor } from 'resources/helpers/helper';
import { formatMoney } from 'utils/text';

const ServersMobileView : React.FC<{}> = () => {
    const { translate } = useContext(I8nContext);
    const items = useSelector(serverStatisticsSelector, shallowEqual);

    const { avgTicket, guestCount, avgRating } = useMemo(() => {
        if(!items) return {
            avgTicket: 0,
            guestCount: 0,
            avgRating: 0,
        };
        let avgTicket = 0;
        let ticketCount = 0;
        let guestCount = 0;
        let avgRating = 0;
        let ratingCount = 0;

        for(const item of Object.values(items)) {
            if(item.avgAmount) {
                avgTicket += item.avgAmount;
                ticketCount += 1;
            }
            if(item.guests) {
                guestCount += item.guests;
            }
            if(item.rating) {
                avgRating += item.rating;
                ratingCount += 1;
            }
        }

        return {
            avgTicket: avgTicket / ticketCount || 0,
            guestCount: guestCount || 0,
            avgRating: avgRating / ratingCount || 0,
        };
    }, [items]);
    

    return (
      <Grid>
                <Box background={colors.white} radius="8px" className="minutes">
                    <Container color={getCheckAmountColor(avgTicket)}>
                        <h1>{avgTicket !== 0 ? formatMoney(avgTicket) : '-'}</h1>
                        <h2> {translate("AVG_TICKET")} </h2>
                    </Container>
                </Box>
            
                <Box background={colors.white} radius="8px" className="active">
                    <Container>
                        <h1>{guestCount}</h1>
                        <p> {translate("GUEST_COUNT")} </p>
                    </Container>
                </Box>
            
                <Box background={colors.white} radius="8px" className="completed">
                    <Container color={getColor(avgRating)}>
                        <h1>{avgRating.toFixed(1)}</h1>
                        <p> {translate("RATING")} </p>
                    </Container>
                </Box>
            </Grid>
    )
};

export default ServersMobileView;